<ng-content select="[tiimeListItemIcon]"></ng-content>
<div class="tiime-list-item-content">
  <ng-content select="[tiimeListItemTitle]"></ng-content>
  <ng-content></ng-content>
</div>
<ng-content select="[tiimeListItemActions]"></ng-content>
